import { useEffect,useState } from "react"
import { createUrl, get } from "../../../network/AxiosInterceptor"
import { TripBookingsView } from "./tripBookingsView"

export const TripBookings = () => {

    const [bookingData,setBookingData] = useState([]);

    const getTripBookings = async () => {
        get(createUrl(`/api/payment/bookings`),{}).then(resp => {
            setBookingData(resp?.data)
        }).catch(err => {
            console.log(err);
        })
    }

    useEffect(() => {
        getTripBookings();
    },[]);

    return (
        <TripBookingsView bookingData={bookingData} />
    )
}